import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import BoxScore from '../../components/game/BoxScore'
import { regularBoxscoreRequest } from '../../modules/game/gameSchedule'

const RegularLeagueBoxScoreContainer = ({ match }) => {

  const boxscore = useSelector(state => state.wizData.data && state.wizData.data['BOXSCORE_REGULAR'])
  // const boxscoreError = useSelector(state => state.wizData.error && state.wizData.error['BOXSCORE_REGULAR'])

  console.log(match)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(regularBoxscoreRequest(match.params.gameId, match.params.gameDate))
  }, [match.params.gameId, match.params.gmkey])

  return (
    <BoxScore league="regular" boxscore={boxscore} />
  )
}

export default RegularLeagueBoxScoreContainer
